import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CustomHamburgerMenuService {
  isExpanded: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  toggle(): void {}
}
